import React, { useState, useEffect } from 'react'
import { KTCard, KTCardBody } from '../../../../_metronic/helpers'
import { KTIcon } from '../../../../_metronic/helpers'
// Local Tag type for edit modal
interface TagItem {
  id: number
  tag_title: string
  description: string
  created_at: string
  updated_at: string
  status: number
}

interface EditTagProps {
  tag: TagItem
  onClose: () => void
  onSave: (tag: TagItem) => void
}

const EditTag: React.FC<EditTagProps> = ({ tag, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    tag_title: tag.tag_title,
    description: tag.description,
    status: tag.status
  })
  const [errors, setErrors] = useState<Record<string, string>>({})

  useEffect(() => {
    setFormData({
      tag_title: tag.tag_title,
      description: tag.description,
      status: tag.status
    })
  }, [tag])

  const validateForm = () => {
    const newErrors: Record<string, string> = {}

    if (!formData.tag_title.trim()) {
      newErrors.tag_title = 'Tag title is required'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    if (validateForm()) {
      onSave({
        ...tag,
        tag_title: formData.tag_title.trim(),
        description: formData.description.trim(),
        status: formData.status
      })
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  return (
    <div className='modal fade show d-block' style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <KTCard>
            <div className='card-header'>
              <div className='card-title'>
                <h3 className='fw-bold text-dark'>Edit Tag</h3>
              </div>
              <div className='card-toolbar'>
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-active-color-primary'
                  onClick={onClose}
                >
                  <KTIcon iconName='cross' className='fs-1' />
                </button>
              </div>
            </div>
            <KTCardBody>
              <form onSubmit={handleSubmit}>
                <div className='row mb-6'>
                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6'>
                      <span className='text-danger'>*</span>Tag Title
                    </label>
                    <input
                      type='text'
                      name='tag_title'
                      className={`form-control form-control-solid ${errors.tag_title ? 'is-invalid' : ''}`}
                      placeholder='Enter tag title'
                      value={formData.tag_title}
                      onChange={handleChange}
                    />
                    {errors.tag_title && <div className='invalid-feedback'>{errors.tag_title}</div>}
                  </div>
                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6'>Status</label>
                    <select
                      name='status'
                      className='form-select form-select-solid'
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value={1}>Active</option>
                      <option value={0}>Inactive</option>
                    </select>
                  </div>
                </div>

                <div className='row mb-6'>
                  <div className='col-lg-12'>
                    <label className='col-form-label fw-bold fs-6'>
                      Description
                    </label>
                    <textarea
                      name='description'
                      className={`form-control form-control-solid ${errors.description ? 'is-invalid' : ''}`}
                      rows={3}
                      placeholder='Enter tag description'
                      value={formData.description}
                      onChange={handleChange}
                    />
                    {errors.description && <div className='invalid-feedback'>{errors.description}</div>}
                  </div>
                </div>


                <div className='d-flex justify-content-end'>
                  <button
                    type='button'
                    className='btn btn-light me-3'
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type='submit'
                    className='btn btn-primary'
                  >
                    <KTIcon iconName='check' className='fs-2' />
                    Update Tag
                  </button>
                </div>
              </form>
            </KTCardBody>
          </KTCard>
        </div>
      </div>
    </div>
  )
}

export { EditTag }

